import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  class: "nav-area"
};
const _hoisted_2 = {
  class: "nav-left"
};
const _hoisted_3 = {
  key: 2,
  class: "nav-right"
};
import { onMounted, ref, computed, nextTick, onActivated } from 'vue';
import { useStore } from 'vuex';
import { useLess } from '@/models/hooks';
import constants from '@/constants';
import { useRoute } from 'vue-router';
export default {
  __name: 'Navigator',
  props: {
    // title
    title: {
      type: String,
      default: ''
    },
    // Middle Content Alignment
    contentPosition: {
      type: String,
      default: 'center'
    },
    // Do you need a bottom border
    isDivider: {
      type: Boolean,
      default: true
    },
    // Background color
    bgColor: {
      type: String,
      default: ''
    },
    isBack: {
      type: Boolean,
      default: true
    },
    isShowTitleStyle: {
      type: Boolean,
      default: true
    }
  },
  emits: ['onBack'],
  setup(__props, {
    emit
  }) {
    useLess('components/Navigator.less');
    const {
      IMAGE_URL
    } = constants;
    // Using store
    const store = useStore();
    const route = useRoute();
    // nav dom
    const navRef = ref(null);
    const BACK_ICON_LINK = `${IMAGE_URL}assets/svg/IconBack.svg`;
    const distanceFromTop = computed(() => {
      var _store$state$navigato;
      return (_store$state$navigato = store.state.navigator.agentData) === null || _store$state$navigato === void 0 ? void 0 : _store$state$navigato.top;
    });

    // Callback to parent component method
    const onBack = () => emit('onBack');
    const handleStoreNavHeight = async () => {
      var _navRef$value;
      await nextTick();
      // Obtain Navigation Altitude
      const topNavHeight = (_navRef$value = navRef.value) === null || _navRef$value === void 0 ? void 0 : _navRef$value.clientHeight;
      // Navigation height saved to store
      if (topNavHeight) store.commit('navigator/setNavHeight', topNavHeight);
    };
    onActivated(() => {
      if (route.meta.keepAlive) handleStoreNavHeight();
    });
    onMounted(() => {
      if (!route.meta.keepAlive) handleStoreNavHeight();
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        ref_key: "navRef",
        ref: navRef,
        style: _normalizeStyle({
          background: __props.bgColor
        }),
        class: _normalizeClass({
          'nav-wrapper': true,
          'nav-wrapper-border': __props.isDivider
        })
      }, [_createElementVNode("div", {
        class: "nav-area-distance-top",
        style: _normalizeStyle({
          height: distanceFromTop.value + 'px'
        })
      }, null, 4), _createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_ctx.$slots.NavLeft ? _renderSlot(_ctx.$slots, "NavLeft", {
        key: 0
      }) : _createCommentVNode("", true), !_ctx.$slots.NavLeft && __props.isBack ? (_openBlock(), _createElementBlock("img", {
        key: 1,
        src: BACK_ICON_LINK,
        alt: "",
        onClick: onBack
      })) : _createCommentVNode("", true)]), _ctx.$slots.NavContent ? _renderSlot(_ctx.$slots, "NavContent", {
        key: 0
      }) : (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: _normalizeClass({
          'nav-center': __props.contentPosition === 'center' ? true : false,
          'nav-center-flex': __props.contentPosition !== 'center' ? true : false,
          'nav-title': __props.isShowTitleStyle
        }),
        style: _normalizeStyle({
          'justify-content': __props.contentPosition !== 'center' ? __props.contentPosition : 'flex-start'
        })
      }, [_createElementVNode("span", null, _toDisplayString(__props.title), 1)], 6)), _ctx.$slots.NavRight ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_renderSlot(_ctx.$slots, "NavRight")])) : _createCommentVNode("", true)])], 6);
    };
  }
};